<template>
<main class="L_ShopHolder">
    <div class="G_HeadingFont L_ShopSectionHolder" v-for="ShopCategory in ShopCategories" :key="ShopCategory">
        <div class="G_DisplayRowNowrap G_Border G_BorderRadius L_ShopCategoryItem" :style="{ backgroundImage: 'url(\''+ShopCategory.Image+'\')' }">
            <div class="G_BorderRadius L_ShopCategoryItemText" @click="SetSelectedComp(ShopCategory.ShopItems)">
                {{ ShopCategory.Name }}
            </div>
        </div>
    </div>
</main>
</template>

<script>
import FudgeCategoryImage from '../../../assets/images/shop/categories/fudge/FudgeCategory.jpg'
import BrownieCategoryImage from '../../../assets/images/shop/categories/brownies/BrowniesCategory.jpg'
import OtherCategoryImage from '../../../assets/images/shop/categories/other/OtherCategory.jpg'

export default {
    data() {
        return {
            ShopCategories: {
                "Fudge": {
                    Name: "Fudge",
                    Image: FudgeCategoryImage,
                    ShopItems: [{
                        ImagePath: "Traditional.jpg",
                        Description: "Traditional",
                        Price: 40,
                        Reference: "Traditional",
                        Qty: 1,
                        Weight: "190g",
                        Pieces: "8 Pieces of 2.5cm x 4.5cm",
                        BasketButtonCaption: "Add to Basket"
                    }, {
                        ImagePath: "TopDeck.jpg",
                        Description: "Topdeck",
                        Price: 40,
                        Reference: "Topdeck",
                        Qty: 1,
                        Weight: "190g",
                        Pieces: "8 Pieces of 2.5cm x 4.5cm",
                        BasketButtonCaption: "Add to Basket"
                    }, {
                        ImagePath: "SpeckledEggs.jpg",
                        Description: "Speckled Egg",
                        Price: 40,
                        Reference: "Speckled Egg",
                        Qty: 1,
                        Weight: "190g",
                        Pieces: "8 Pieces of 2.5cm x 4.5cm",
                        BasketButtonCaption: "Add to Basket"
                    }, {
                        ImagePath: "MilkyBar.jpg",
                        Description: "Milkybar",
                        Price: 40,
                        Reference: "MilkyBar",
                        Qty: 1,
                        Weight: "190g",
                        Pieces: "8 Pieces of 2.5cm x 4.5cm",
                        BasketButtonCaption: "Add to Basket"
                    }, {
                        ImagePath: "Oreo.jpg",
                        Description: "Oreo",
                        Price: 40,
                        Reference: "Oreo",
                        Qty: 1,
                        Weight: "190g",
                        Pieces: "8 Pieces of 2.5cm x 4.5cm",
                        BasketButtonCaption: "Add to Basket"
                    }, {
                        ImagePath: "ChocOreo.jpg",
                        Description: "Choc Oreo",
                        Price: 40,
                        Reference: "Choc Oreo",
                        Qty: 1,
                        Weight: "190g",
                        Pieces: "8 Pieces of 2.5cm x 4.5cm",
                        BasketButtonCaption: "Add to Basket"
                    }, {
                        ImagePath: "RomanyCreams.jpg",
                        Description: "Romany Cream",
                        Price: 40,
                        Reference: "Romany Cream",
                        Qty: 1,
                        Weight: "190g",
                        Pieces: "8 Pieces of 2.5cm x 4.5cm",
                        BasketButtonCaption: "Add to Basket"
                    }, {
                        ImagePath: "Bubbly.jpg",
                        Description: "Bubbly",
                        Price: 40,
                        Reference: "Bubbly",
                        Qty: 1,
                        Weight: "190g",
                        Pieces: "8 Pieces of 2.5cm x 4.5cm",
                        BasketButtonCaption: "Add to Basket"
                    }, {
                        ImagePath: "Rolo.jpg",
                        Description: "Rolo",
                        Price: 40,
                        Reference: "Rolo",
                        Qty: 1,
                        Weight: "190g",
                        Pieces: "8 Pieces of 2.5cm x 4.5cm",
                        BasketButtonCaption: "Add to Basket"
                    }, {
                        ImagePath: "Amarula.jpg",
                        Description: "Amarula",
                        Price: 55,
                        Reference: "Amarula",
                        Qty: 1,
                        Weight: "265g",
                        Pieces: "8 Pieces of 2.5cm x 4.5cm",
                        alcoholic: "true",
                        BasketButtonCaption: "Add to Basket"
                    }, {
                        ImagePath: "Milktart.jpg",
                        Description: "Milktart",
                        Price: 55,
                        Reference: "Milktart",
                        Qty: 1,
                        Weight: "265g",
                        Pieces: "8 Pieces of 2.5cm x 4.5cm",
                        alcoholic: "true",
                        BasketButtonCaption: "Add to Basket"
                    }, {
                        ImagePath: "CookiesAndCream.jpg",
                        Description: "Cookies and Cream",
                        Price: 65,
                        Reference: "Cookies And Cream",
                        Qty: 1,
                        Weight: "265g",
                        Pieces: "8 Pieces of 2.5cm x 4.5cm",
                        alcoholic: "true",
                        BasketButtonCaption: "Add to Basket"
                    }]
                },
                "Brownies": {
                    Name: "Brownies",
                    Image: BrownieCategoryImage,
                    ShopItems: [{
                            ImagePath: "BrowniePlain.jpg",
                            Description: "Brownies",
                            Price: 75,
                            Reference: "Brownie",
                            Qty: 1,
                            Pieces: "6 pieces of Chocolate brownies topped with chocolate sauce",
                            BasketButtonCaption: "Add to Basket"
                        },
                        {
                            ImagePath: "BrownieSpeckled.jpg",
                            Description: "Topped Brownies",
                            Price: 85,
                            Reference: "Brownie Tray with Topping",
                            Qty: 1,
                            Pieces: "6 Pieces of Chocolate brownies topped with chocolate sauce and topping of your choice",
                            BasketButtonCaption: "Add to Basket"
                        },
                        {
                            ImagePath: "BrownieTub.jpg",
                            Description: "Brownie Tub",
                            Price: 35,
                            Reference: "Brownie Tub",
                            Qty: 1,
                            Pieces: "Brownies, Chocolate sauce and toppings of your choice",
                            BasketButtonCaption: "Add to Basket"
                        },
                    ]
                },
                "Other": {
                    Name: "Others",
                    Image: OtherCategoryImage,
                    ShopItems: [{
                            ImagePath: "CoconutIce.jpg",
                            Description: "Coconut Ice",
                            Price: 20,
                            Reference: "Coconut Ice",
                            Qty: 1,
                            Weight: "90g",
                            BasketButtonCaption: "Add to Basket"
                        },
                        {
                            ImagePath: "RiceKrispy.jpg",
                            Description: "Rice Krispy Treat",
                            Price: 10,
                            Reference: "Rice Krispy",
                            Qty: 1,
                            Pieces: "6cm x 8cm",
                            BasketButtonCaption: "Add to Basket"
                        },
                        {
                            ImagePath: "RockyRoad.jpg",
                            Description: "Rocky Road",
                            Price: 12,
                            Reference: "Rocky Road",
                            Qty: 1,
                            Pieces: "Marshmallows, White chocolate and Marie Biscuits",
                            BasketButtonCaption: "Add to Basket"
                        },
                        {
                            ImagePath: "ChocMarie.jpg",
                            Description: "Choc Marie Biscuits",
                            Price: 12,
                            Reference: "Choc Marie Biscuit",
                            Qty: 1,
                            Pieces: "Chocolate and Marie Biscuits",
                            BasketButtonCaption: "Add to Basket"
                        }
                    ]
                }
            }
        }
    },
    methods: {
        SetSelectedComp(ShopItems) {
            this.$emit('SetSelectedComp', 'Shop Category', ShopItems)
        }
    }
}
</script>

<style lang="scss">
@import "../../../assets/GlobalCss.scss";

.L_ShopHolder {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;

    @include mobile() {
        flex-flow: column nowrap;
    }
}

.L_ShopSectionHolder {
    width: 100%;
    height: 30rem;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;

    @include mobile() {
        flex-flow: column nowrap;
        height: 15rem;
    }
}

.L_ShopCategoryItem {
    width: 20rem;
    height: 10rem;
    align-items: center;
    justify-content: center;
    background-size: 100% 100%;

    @include mobile() {
        width: 25rem;
        height: 12rem;
    }
}

.L_ShopCategoryItem:hover {
    cursor: pointer;
    transition: transform .2s;
    transform: scale(1.02);
}

.L_ShopCategoryItemText {
    width: 70%;
    background-color: #ffffff;
    box-shadow: 5px 5px #888888;
    text-align: center;
}
</style>
